
<template>
  <div class="utm-control-group">
    <div class="utm-control-label must-fill" style="width: auto;" v-if="isWathchStyle">Office</div>
    <label class="utm-control-label must-fill" :style="{'width':labelWidth}" v-else>Office</label>
    <div class="utm-controls utm-controls-office" :style="{'margin-bottom':marginBottom,'width':InputWidth, 'margin-left':0}" v-if="isWathchStyle">
      <!--存在默认的Office-->
      <Select :disabled="isDisabled"
              v-model="objInfo.officeId" 
              filterable filter-by-label
              class="utm-select utm-select-option"
              placeholder="Please select office" @on-change="changeOffice">
          <Option v-for="(office) in officeList" :key="office.if" :value="office.id" :label="office.name">
            <utm-ellipsis :style="{'max-width': InputWidth}" :content="office.name" transfer>
              <div style="max-width: 100%;">{{office.name }} <span class="desc-span">( {{office.timeZoneName}})</span></div>
            </utm-ellipsis>
          </Option>
      </Select>
      <span v-show="officeFlag" class="utm-is-danger">Please select office</span>
      <slot name="tip"></slot>
    </div>
    <div class="utm-controls utm-controls-office" :style="{'margin-bottom':marginBottom,'width':InputWidth, 'margin-left':labelWidth}" v-else>
      <!--存在默认的Office-->
      <Select :disabled="isDisabled"
              v-model="objInfo.officeId"
              filterable filter-by-label
              class="utm-select utm-select-option"
              placeholder="Please select office" @on-change="changeOffice">
          <Option v-for="(office) in officeList" :key="office.if" :value="office.id" :label="office.name">
            <utm-ellipsis :style="{'max-width': InputWidth}" :content="office.name" transfer>
              <div style="max-width: 100%;">{{office.name }} <span class="desc-span">( {{office.timeZoneName}})</span></div>
            </utm-ellipsis>
          </Option>
      </Select>
      <span v-show="officeFlag" class="utm-is-danger">Please select office</span>
      <slot name="tip"></slot>
    </div>
  </div>
</template>

<script>
 /*************
  * 选择Office规则,当系统Office选项为All的时候才需要显示Office，如果已经选择了显示的Office，则默认为该Office；
  * 当默认Office后，不可自行更改Office，但需要显示该默认Office；
  * 修改数据时不可以更换Office
  * ****************/
export default {
  name: "utmSelectOffice",
  props:{
    /*标题右对齐需要的宽度*/
    labelWidth:{
      type: String,
      default: ''
    },
    /*需要保存数据的对象*/
    objInfo:{
      type:Object,
      default:() => {
        return {
          officeId:''
        }
     },
    },
    /*是否是修改界面*/
    isEdit: {
      type: Boolean,
      default: false
    },
    //是否提示office是否选择了
    officeFlag:{
      type:Boolean,
      default:false
    },
    marginBottom:{
      type:String
    },
    InputWidth:{
      type:String
    },
    isWathchStyle:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return{
      isDisabled:false,
      officeList:this.$root.offices,
    }
  },
  mounted(){
    console.log('this.$root.offices',this.$root.offices);
    if(this.$root.offices.length > 0 && this.$root.curNodeInfo.id === null){
      console.log('this.objInfo.targetNodeId',this.objInfo.targetNodeId);
      if(!this.objInfo.targetNodeId) {
        return
      }
      this.officeList = this.$root.offices.filter(office => this.objInfo.targetNodeId === office.buildingId);
    }else if(this.$root.offices.length > 0 && this.$root.curNodeInfo.id !== null){
      this.officeList = this.$root.offices.filter(office => this.$root.curNodeInfo.id === office.buildingId);
      console.log(this.$root.curNodeInfo.id);
    }
    //当没有默认Office时，默认选择Office数据的第一个
    if(!this.isEdit){
      // 系统右上角没有选择具体的Office
      if((!this.$root.curOfficeInfo || !this.$root.curOfficeInfo.id) && this.$root.offices.length > 0 && !this.objInfo.officeId){
        // 默认选择该节点的默认Office
        let nodeIndex = this.officeList.findIndex( el => el.isDefault);
        if(nodeIndex > -1){
          let office = this.officeList[nodeIndex];
          this.objInfo.officeId = office.id;
          this.objInfo.timeZoneId = office.timeZoneId;
          this.$emit('changeOffice', office);
        }else{
          // 没有默认Office就选择第一个
          let office = this.officeList[0];
          this.objInfo.officeId = office.id;
          this.objInfo.timeZoneId = office.timeZoneId;
          this.$emit('changeOffice',office);
        }
        this.isDisabled = false;
      }else if(this.$root.curOfficeInfo && this.$root.curOfficeInfo.id && !this.objInfo.officeId){
        this.objInfo.officeId = this.$root.curOfficeInfo.id;
        this.objInfo.timeZoneId = this.$root.curOfficeInfo.timeZoneId;
        this.isDisabled = true;
        this.$emit('changeOffice', this.$root.curOfficeInfo);
      }
    }else{
      if(!this.objInfo.officeId){
          this.isDisabled = false;
      }else{
          this.isDisabled = true;
      }
    }
  },
  watch: {
    'objInfo.targetNodeId':function(newValue){
      if((!this.$root.curNodeInfo || !this.$root.curNodeInfo.id) && this.$root.nodes.length > 0){
            this.$ajax.post('Office/PagingOption',{sortName:'name',sortType:0,enabledPaging:false,buildingIds:[newValue]}).then(res=>{
          if(res.data.success && res.data.data.items.length > 0){
            this.officeList = res.data.data.items;
            // 判断当前的office是否就是该节点的
            if((!this.$root.curOfficeInfo || !this.$root.curOfficeInfo.id) && this.$root.offices.length > 0){
                let index =  this.officeList.findIndex( el => el.id === this.objInfo.officeId);
                if(index > -1){
                  return false;
                }
                // 默认选择该节点的默认Office
                let nodeIndex = this.officeList.findIndex( el => el.isDefault);
                if(nodeIndex > -1){
                  this.objInfo.officeId = this.officeList[nodeIndex].id;
                  this.objInfo.timeZoneId = this.officeList[nodeIndex].timeZoneId;
                  this.$emit('changeOffice',this.officeList[nodeIndex]);
                }else{
                  // 没有默认Office就选择第一个
                  this.objInfo.officeId = this.officeList[0].id;
                  this.objInfo.timeZoneId = this.officeList[0].timeZoneId;
                  this.$emit('changeOffice',this.officeList[0]);
                }
                this.isDisabled = false;
            }
          }
        })
      }
    },
    isEdit:function(newValue){
      this.isDisabled = newValue;
    }
  },
  methods:{
    changeOffice:function(value){
      let index = this.$root.offices.findIndex(el => el.id === value);
      if(index > -1){
        this.objInfo.timeZoneId =  this.$root.offices[index].timeZoneId;
        this.$emit('changeOffice', this.$root.offices[index]);
      }
    },
  },
}
</script>

<style scoped>
.utm-controls-office .desc-span {
    color: #b4b4b4;
}
/* User 模块Office 的样式（定制化的） */
.office-swapper-tip .utm-controls-office{
  position: relative;
}
.office-swapper .utm-controls-office .utm-select {
  width: calc(100% - 48px);
  margin-right: 8px;
  vertical-align: top;
} 
.office-swapper-tip .utm-controls-office .user-office-prompt{
  display: inline-block;
  font-size: 16px;
  position: absolute;
  top: 8px;
  left: 100%;
  white-space: nowrap;
  margin: 0 8px;
}
/* User 模块Office 的样式（定制化的） */
</style>



// WEBPACK FOOTER //
// src/admin/components/commonComponents/utmSelectOffice.vue